export const INSPECTOR_PALETTE = [
  '#007bff', // blue
  '#6f42c1', // purple
  '#28a745', // green
  '#dc3545', // red
  '#20c997', // teal
  '#e83e8c', // pink
  '#17a2b8', // cyan
  '#34495e', // dark slate
  '#d97706', // amber
  '#4f46e5', // indigo
];

export const getInspectorColor = (inspectorId, inspectorsList = []) => {
  if (!inspectorId || inspectorId === 'null' || inspectorId === 'waiting') {
    return '#fd7e14';
  }

  const index = inspectorsList.findIndex(insp => String(insp?.public_id || insp?.id) === String(inspectorId));
  if (index >= 0) {
    return INSPECTOR_PALETTE[index % INSPECTOR_PALETTE.length];
  }

  const idStr = String(inspectorId);
  let hash = 0;
  for (let i = 0; i < idStr.length; i += 1) {
    hash = idStr.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colorIndex = Math.abs(hash) % INSPECTOR_PALETTE.length;
  return INSPECTOR_PALETTE[colorIndex];
};

export const getInitials = name => {
  const words = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!words.length) return '--';

  return `${words[0][0]}${words.length > 1 ? words[words.length - 1][0] : ''}`.toUpperCase();
};
